import { HashRouter, Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AppLayout } from "./layouts/AppLayout";

import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";
import SSOCallback from "./pages/auth/SSOCallback";

import Dashboard from "./pages/Dashboard";
import Assets from "./pages/Assets";
import AssetDetail from "./pages/AssetDetail";
import PointClouds from "./pages/PointClouds";
import PointCloudViewer from "./pages/PointCloudViewer";
import DigitalTwins from "./pages/DigitalTwins";
import DigitalTwinViewer from "./pages/DigitalTwinViewer";
import Maintenance from "./pages/Maintenance";
import Risk from "./pages/Risk";
import Instrumentation from "./pages/Instrumentation";
import DocumentManagementSystem from "./pages/DocumentManagementSystem";
import Settings from "./pages/Settings";

export function AppRouter() {
  return (
    <HashRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/sso/callback" element={<SSOCallback />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="assets" element={<Assets />} />
          <Route path="assets/:id" element={<AssetDetail />} />
          <Route path="point-clouds" element={<PointClouds />} />
          <Route path="point-clouds/:id" element={<PointCloudViewer />} />
          <Route path="digital-twins" element={<DigitalTwins />} />
          <Route path="digital-twins/:id" element={<DigitalTwinViewer />} />
          <Route path="maintenance" element={<Maintenance />} />
          <Route path="risk" element={<Risk />} />
          <Route path="instrumentation" element={<Instrumentation />} />
          <Route path="instrumentation/devices/:deviceId" element={<Instrumentation />} />
          <Route path="instrumentation/sensors/:sensorId" element={<Instrumentation />} />
          <Route path="dms" element={<DocumentManagementSystem />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}
